import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';

function TermsOfService() {
  return (
    <Box sx={{ py: { xs: 8, md: 15 }, bgcolor: '#f9f9f9', minHeight: '100vh' }}>
      <Container maxWidth="lg">
        <Typography variant="h2" fontWeight={900} align="center" gutterBottom sx={{ color: '#034522', mb: 6, fontSize: { xs: '2.5rem', md: '3.75rem' } }}>
          Terms of Service
        </Typography>
        <Paper elevation={0} sx={{ p: { xs: 4, md: 8 }, borderRadius: 6, border: '1px solid #e0e0e0' }}>
          <Box mb={6}>
            <Typography variant="h5" gutterBottom fontWeight={800} color="#034522">Last Updated: December 25, 2025</Typography>
            <Typography paragraph color="text.secondary" sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
              Welcome to the GrowAITech website (the "Site"), owned and operated by GrowAITech Solutions Pvt Ltd ("Company", "we", "us", or "our"). By accessing or using our Site and services, you ("User", "you") agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
            </Typography>
          </Box>

          {[
            {
              title: "1. Services & Engagement",
              content: "GrowAITech provides software development, consulting, and IT services. Engaging with us typically involves a separate Service Level Agreement (SLA) or Master Services Agreement (MSA). In the event of a conflict between these Terms and a specific SLA/MSA, the terms of the SLA/MSA shall control regarding that specific engagement."
            },
            {
              title: "2. Intellectual Property Rights",
              content: "All content, features, and functionality on this Site—including but not limited to code, designs, text, graphics, logos, and software—are the exclusive property of GrowAITech and are protected by international copyright, trademark, and intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission."
            },
            {
              title: "3. User Responsibilities",
              content: "By using our Site, you agree not to: (a) Use the Site for any illegal purpose; (b) Attempt to gain unauthorized access to our systems or networks; (c) Introduce viruses, trojans, or other malicious code; (d) Use any automated data gathering or extraction tools."
            },
            {
              title: "4. Confidentiality",
              content: "We treat all client data as strictly confidential. If you share proprietary information with us during a consultation or project discovery phase, we are bound by our standard Non-Disclosure Agreement (NDA) terms, available upon request."
            },
            {
              title: "5. Limitation of Liability",
              content: "To the fullest extent permitted by law, GrowAITech shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits or data, arising out of or in connection with your use of the Site or our services."
            },
            {
              title: "6. Payment & Refunds",
              content: "Payment terms for our services are defined in individual project contracts. For any rigorous fixed-price packages purchased directly through the Site (if applicable), refunds are subject to the terms specified at the time of purchase. Generally, fees for completed milestones are non-refundable."
            },
            {
              title: "7. Termination",
              content: "We reserve the right to terminate or suspend your access to our Site immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms."
            },
            {
              title: "8. Dispute Resolution",
              content: "Any disputes arising out of or related to these Terms shall be amicably resolved through mediation. If mediation fails, the dispute shall be subject to the exclusive jurisdiction of the courts located in Salem, Tamil Nadu, India."
            }
          ].map((section, index) => (
            <Box key={index} mb={4}>
              <Typography variant="h5" fontWeight={700} sx={{ color: '#1A9E7F', mb: 2 }}>
                {section.title}
              </Typography>
              <Typography paragraph color="#333" sx={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                {section.content}
              </Typography>
              <Divider sx={{ my: 3, opacity: 0.5 }} />
            </Box>
          ))}

          <Box mt={6} p={4} bgcolor="#F0F9F6" borderRadius={4}>
            <Typography variant="h6" fontWeight={700} gutterBottom color="#034522">Contact Us</Typography>
            <Typography paragraph mb={0}>
              If you have any questions about these Terms, please contact our Legal Department at:
            </Typography>
            <Typography variant="body1" fontWeight={700} color="#1A9E7F" mt={1}>
              legal@growaitech.com
            </Typography>
          </Box>

        </Paper>
      </Container>
    </Box>
  );
}

export default TermsOfService;
